import { ItemCounterWrapper, CounterIcon, Counter } from './ItemCounter.styles'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { Proteins } from 'models/Pet'

type ItemCounterProps = {
  counter: number
  onAdd: () => void
  onRemove: () => void
  recipe?: Proteins
}

export const ItemCounter = ({ counter, onAdd, onRemove, recipe }: ItemCounterProps) => {
  return (
    <ItemCounterWrapper>
      <CounterIcon
        recipe={recipe || undefined}
        disabled={counter <= 1 ? true : false}
        onClick={() => {
          if (counter > 1) {
            onRemove()
          }
        }}
      >
        <Icon name="minus" color="accent-black" size="3" />
      </CounterIcon>
      <Counter>
        <Text size="bodyExtraLarge" color="accent-black">
          {counter}
        </Text>
      </Counter>
      <CounterIcon recipe={recipe} onClick={onAdd}>
        <Icon name="plus" color="accent-black" size="3" />
      </CounterIcon>
    </ItemCounterWrapper>
  )
}
